(function(){
  if(window.JIYUCHO_RESERVABLE_TIME_RULES) return;

  function pad(n){ return String(n).padStart(2, '0'); }
  function schedule(){ return window.JIYUCHO_SCHEDULE || null; }
  function toHm(date){
    var S = schedule();
    var J = S && typeof S.getJstComponents === 'function' ? S.getJstComponents(date) : null;
    return J ? pad(J.h) + ':' + pad(J.mn) : '';
  }
  function parseLocalDate(value){
    if(!value) return null;
    if(value instanceof Date) return isNaN(value) ? null : value;
    var S = schedule();
    if(S && typeof S.parseAsJSTLocalInput === 'function'){
      var jst = S.parseAsJSTLocalInput(value);
      if(jst) return jst;
    }
    var raw = String(value).trim();
    var m = raw.match(/^(\d{4})[-\/](\d{1,2})[-\/](\d{1,2})(?:[T\s](\d{1,2}):(\d{2}))?$/);
    if(m){
      var y = parseInt(m[1],10);
      var mo = parseInt(m[2],10) - 1;
      var d = parseInt(m[3],10);
      var h = parseInt(m[4] || '0',10);
      var mi = parseInt(m[5] || '0',10);
      var dt = new Date(Date.UTC(y, mo, d, h - 9, mi, 0, 0));
      return isNaN(dt) ? null : dt;
    }
    var parsed = new Date(raw);
    return isNaN(parsed) ? null : parsed;
  }
  function parseHmToMinutes(hm){
    var m = String(hm||'').match(/^(\d{1,2}):(\d{2})$/);
    if(!m) return null;
    return parseInt(m[1],10) * 60 + parseInt(m[2],10);
  }
  function isHolidayOrWeekend(date){
    if(!date || isNaN(date)) return false;
    var S = schedule();
    var J = S && typeof S.getJstComponents === 'function' ? S.getJstComponents(date) : null;
    var weekend = J ? (J.dow === 0 || J.dow === 6) : false;
    var holiday = false;
    if(window.JIYUCHO_SCHEDULE && typeof window.JIYUCHO_SCHEDULE.isHolidayInJapan === 'function'){
      try { holiday = !!window.JIYUCHO_SCHEDULE.isHolidayInJapan(date); } catch(e) {}
    }
    return weekend || holiday;
  }
  function normalizeText(v){
    return String(v || '').toLowerCase().replace(/[\s\u3000]+/g, '');
  }
  function isLetterReservationMenu(menu){
    var S = schedule();
    if(S && typeof S.isLetterReservationMenu === 'function') return S.isLetterReservationMenu(menu);
    var t = normalizeText(menu);
    if(!t) return false;
    if(t.indexOf('acupofletter') >= 0 || t.indexOf('acol') >= 0 || t.indexOf('②') >= 0) return false;
    if(t.indexOf('①') >= 0 || t.indexOf('future') >= 0) return true;
    if(t.indexOf('t-price') >= 0) return true;
    if(t.indexOf('一年後の自分へ手紙を書く') >= 0) return true;
    if(t.indexOf('手紙') >= 0 || t.indexOf('letter') >= 0) return true;
    if(t.indexOf('writealettertoyourfutureself') >= 0) return true;
    return false;
  }
  function shouldUseLetterTimeLimit(menu){
    var t = normalizeText(menu);
    if(!t) return true;
    return isLetterReservationMenu(menu);
  }
  function getMenuLimitOffsetMinutes(menu){
    var S = schedule();
    if(S && typeof S.getMenuLimitOffsetMinutes === 'function') return S.getMenuLimitOffsetMinutes(menu);
    return shouldUseLetterTimeLimit(menu) ? 90 : 30;
  }
  function getClosingTimeForDate(store, date){
    var S = window.JIYUCHO_SCHEDULE;
    if(S && typeof S.getBusinessHours === 'function'){
      var r = S.getBusinessHours(date, store);
      if(r && r.close) return r.close;
    }
    return isHolidayOrWeekend(date) ? '20:00' : '18:00';
  }
  function getLatestReservableStartTime(opts){
    opts = opts || {};
    var date = parseLocalDate(opts.date);
    if(!date) return null;
    var S = schedule();
    if(S && typeof S.getLatestReservableStartTime === 'function'){
      return S.getLatestReservableStartTime(date, opts.store || 'JIYUCHO', opts.menu);
    }
    var closeHm = getClosingTimeForDate(opts.store || 'JIYUCHO', date);
    var closeMin = parseHmToMinutes(closeHm);
    if(closeMin == null) return null;
    var latest = closeMin - getMenuLimitOffsetMinutes(opts.menu);
    return pad(Math.floor(latest/60)) + ':' + pad(latest%60);
  }
  function isDateTimeReservable(opts){
    opts = opts || {};
    var date = parseLocalDate(opts.dateTime || opts.date);
    if(!date) return true;
    var S = schedule();
    if(S && typeof S.validateReservationDateTime === 'function'){
      return !!S.validateReservationDateTime(date, opts.store || 'JIYUCHO', opts.menu).ok;
    }
    var latest = getLatestReservableStartTime({ store: opts.store, date: date, menu: opts.menu });
    if(!latest) return true;
    return parseHmToMinutes(toHm(date)) <= parseHmToMinutes(latest);
  }

  window.JIYUCHO_RESERVABLE_TIME_RULES = {
    normalizeStoreKey: function(store){
      var key = String(store || '').trim().toUpperCase();
      return (key === 'FUTO' || key === 'F') ? 'FUTO' : 'JIYUCHO';
    },
    isLetterReservationMenu: isLetterReservationMenu,
    shouldUseLetterTimeLimit: shouldUseLetterTimeLimit,
    getMenuLimitOffsetMinutes: getMenuLimitOffsetMinutes,
    isHolidayOrWeekend: isHolidayOrWeekend,
    getClosingTimeForDate: getClosingTimeForDate,
    getLatestReservableStartTime: getLatestReservableStartTime,
    isDateTimeReservable: isDateTimeReservable
  };
})();
